import { createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles(() =>
  createStyles({
    inputFieldBox: {
      margin: '0 0 24px'
    },
    forgotPasswordBox: {
      margin: '0 0 24px'
    }
  })
);
